import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';

export const listAnswerApprovals = async (
    campaignId: number,
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(
        `admin/surveys/${campaignId}/answer_approvals`,
        {
            params,
        }
    );
    return response.data;
};

export const answerApprovalDetail = async (
    campaignId: number,
    answerId: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(
        `admin/surveys/${campaignId}/answer_approvals/${answerId}`
    );
    return response.data;
};

export const updateAnswerApprovalStatus = async (
    campaignId: number,
    answerId: number,
    status: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.put(
        `admin/surveys/${campaignId}/answer_approvals/${answerId}`,
        {
            status,
        }
    );
    return response.data;
};
